import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { PaymentResponseStatus } from './payment-response.enum';

export class Payment {
	barCode: string;
	dueDate: Date;
	dueDateInput: Date;
	date: Date;
	dateLabel: string;
	value: any;
	scheduleDate: Date;
	assignorName: string;
	assignorCpfCnpj: string;
	paymentId: number;
	message: string;
	success: boolean;
	situation: PaymentResponseStatus;
	resumeList: Array<ListItem>;
	dateType: string;


	codeBarCip: boolean;
	editableFields: boolean;
	securitieIdentification: number;
	toPaymentType: string;
	toPaymentCpfCnpj: string;
	nominalValue: number;
	digitableLine: any;
	securitieLimitDate: any;
	securitieLimitDateLabel: string;
	parcialPayment: boolean;
	securitieRebateValue: number;
	dischargeOperationalType: string;
	taxValue: number;
	fineValue: number;
	discountValue: number;
	totalValue: number;
	calcDateValidity: string;
	paymentBlocked: boolean;
	chargesValue: number;

	minValue: any;
	maxValue: any;

	anyValue: boolean;
	minTypeValue: boolean;
	minMaxTypeValue: boolean;
	totalTypeValue: boolean;

	paymentType: string;
	paymentNameAgreement: string;
	payerAgency: number;
	payerAccount: string;
	payerName: string;
	payerCpfCnpj: string;
	confirmationCode: number;

	constructor() {}
}

export enum TransferType {
	BOLETO = 	'BOLETO'
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/models/payment.ts